/* Outdoors Nordic. Flyttad ur blocks/on-gallery-badges.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
if (customElements.get('on-gallery-badges')) return;
class OnGalleryBadges extends HTMLElement {
connectedCallback() {
var section = this.closest('.shopify-section, [id^="shopify-section"]') || document;
this.gallery = section.querySelector('media-gallery') || document.querySelector('media-gallery');
this.layer = this.querySelector('[data-badges-layer]');
if (!this.gallery || !this.layer) return;
 this.place = this.place.bind(this);
this.place();
 /* Galleriet byter layout vid brytpunkten: slideshow pa mobil, rutnat pa dator.
   Den dolda halvan har 0 bredd, sa lagret maste flytta med nar bredden andras
   eller nar en bild befordras till toppen. */
var self = this;
this.onRe = function () { clearTimeout(self._t); self._t = setTimeout(self.place, 120); };
window.addEventListener('resize', this.onRe);
document.addEventListener('on:gallery:reorder', this.place);
document.addEventListener('variant:update', this.onRe);
this.onVar = function () { [600, 1500].forEach(function (ms) { setTimeout(self.place, ms); }); };
document.addEventListener('variant:update', this.onVar);
[300, 1200].forEach(function (ms) { setTimeout(self.place, ms); });
}
disconnectedCallback() {
if (this.onRe) {
  window.removeEventListener('resize', this.onRe);
  document.removeEventListener('variant:update', this.onRe);
  document.removeEventListener('variant:update', this.onVar);
}
if (this.place) document.removeEventListener('on:gallery:reorder', this.place);
}
/* Lagret ska sitta pa den forsta SYNLIGA huvudbilden: rutnatets forsta ruta pa
 dator, forsta sliden pa mobil. En dold kandidat har bredd 0 och valjs bort. */
place() {
/* Omgång 49: Horizon byter ut <media-gallery> när varianten har egna bilder först, så
   galleriet slås upp på nytt här i stället för att använda det som sparades vid start. */
var sec = this.closest('.shopify-section, [id^="shopify-section"]') || document;
var g = sec.querySelector('media-gallery') || document.querySelector('media-gallery');
if (g) this.gallery = g;
if (!this.gallery || !this.layer) return;
var grid = this.gallery.querySelector('.media-gallery__grid');
var cands = [];
if (grid && grid.firstElementChild) cands.push(grid.firstElementChild);
var slide = this.gallery.querySelector('slideshow-slide');
if (slide) cands.push(slide);
var mc = this.gallery.querySelector('.product-media-container');
if (mc) cands.push(mc);
 var host = null;
for (var i = 0; i < cands.length; i++) {
  var c = cands[i];
  if (c.offsetParent !== null && c.getBoundingClientRect().width > 0) { host = c; break; }
}
if (!host) host = cands[0] || this.gallery;
 if (this.layer.parentElement !== host) {
  var prev = this.gallery.querySelectorAll('.on-bdg--host');
  for (var k = 0; k < prev.length; k++) if (prev[k] !== host) prev[k].classList.remove('on-bdg--host');
  host.classList.add('on-bdg--host');
  host.appendChild(this.layer);
}
// Alltid, aven nar lagret redan satt ratt: remsan kan ha hamnat utanfor.
this.adoptStrips();
}
/* Prisremsan fran on-price-row hor hemma I hornets stack, inte som ett eget
 absolut element ovanpa den. Adoptionen gors HAR och inte i on-price-row
 eftersom lagret flyttas mellan mobilens slideshow och datorns rutnat: kordes
 flytten fran tva hall vann den som rakade springa sist, och vid varje
 brytpunktsbyte lade sig remsan over Bastsaljare. Nu ager badge-blocket
 hornet ensamt och kor adoptionen efter varje flytt. */
adoptStrips() {
var corners = ['tl', 'tr', 'bl', 'br'];
var strips = document.querySelectorAll('[data-prb-gallery]');
for (var i = 0; i < strips.length; i++) {
  var strip = strips[i];
  var corner = 'br';
  for (var c = 0; c < corners.length; c++) {
    if (strip.classList.contains('on-prb--g' + corners[c])) corner = corners[c];
  }
  var stack = this.layer.querySelector('.on-bdg__corner--' + corner);
  if (!stack) continue;
  if (strip.parentElement !== stack) stack.appendChild(strip);
  strip.classList.add('on-prb--instack', 'is-placed');
}
}
}
customElements.define('on-gallery-badges', OnGalleryBadges);
  })();

